import { MenuProps, Menu as MuiMenu } from '@mui/material'
import { tss } from 'tss-react'
import { menuPrimitives } from './primitives'

/**
 * Renders a styled menu component
 */
export function Menu({ className, ...props }: MenuProps) {
  const { cx, classes } = useStyles()
  return <MuiMenu className={cx(classes.menu, className)} {...props} />
}

const useStyles = tss.create({
  menu: menuPrimitives,
})
